var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { spinner } from 'elements/Loading';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            _this.props.onClick();
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, onClick = _a.onClick, loading = _a.loading, store = _a.store, className = _a.className, disabled = _a.disabled, props = __rest(_a, ["children", "onClick", "loading", "store", "className", "disabled"]);
        var isLoading = typeof loading === 'boolean' ? loading : store.UI.isLoading(loading);
        return (React.createElement(StyledButton, __assign({ disabled: disabled, className: className }, props, { onClick: isLoading ? function () { } : this.handleClick, isLoading: isLoading, content: children }),
            React.createElement("span", null, children)));
    };
    Button = __decorate([
        inject('store'),
        observer
    ], Button);
    return Button;
}(Component));
export default Button;
var StyledButton = cxs('button')(function (_a) {
    var content = _a.content, primary = _a.primary, isLoading = _a.isLoading, disabled = _a.disabled;
    return (__assign(__assign(__assign({ position: 'relative' }, typeof content === 'string'
        ? { padding: Theme.size.space[1] }
        : undefined), primary ? {
        color: disabled ? Theme.color.hairline : Theme.color.primary,
        ':hover': {
            color: disabled ? Theme.color.hairline : Theme.color.secondary
        }
    } : {
        color: disabled ? Theme.color.hairline : undefined,
        ':hover': {
            color: disabled ? Theme.color.hairline : Theme.color.primary
        }
    }), isLoading ? __assign({ '> span': { visibility: 'hidden' } }, spinner) : undefined));
});
StyledButton.propTypes = {
    primary: PropTypes.bool,
    isLoading: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Button.tsx
// module id = 228
// module chunks = 0